import React from "react";
import "../CSS/Footer.css";

// Footer for copytight TM.
export const Footer = () => {
  return (
    <>
      <div className="Footer">Made with ❤️ by Aaradhya D. Pathak</div>
    </>
  );
};
